var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cookie-banner" },
    [
      !_vm.hidden
        ? _c("div", { staticClass: "cookie-banner__wrapper" }, [
            _c(
              "div",
              { ref: "content", staticClass: "cookie-banner__content" },
              [
                _c("div", {
                  staticClass:
                    "cookie-banner__title double-sided__content-title double-sided__content-title--colorful color-green",
                  domProps: { innerHTML: _vm._s(_vm.$t("cookiebanner.title")) },
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "cookie-banner__text",
                  domProps: { innerHTML: _vm._s(_vm.$t("cookiebanner.text")) },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "cookie-banner__buttons" },
                  [
                    _c("Button", {
                      attrs: {
                        "data-consent-submit": "",
                        "data-consent-selection": _vm.allCategoriesFormatted,
                        level: "green",
                        type: "button",
                        text: _vm.$t("cookiebanner.acceptAllButton"),
                      },
                      on: { click: _vm.onAccept },
                    }),
                    _vm._v(" "),
                    _c("Button", {
                      attrs: {
                        "data-consent-submit": "",
                        "data-consent-selection": _vm.defaultCookieCategory,
                        level: "grey",
                        type: "button",
                        text: _vm.$t("cookiebanner.acceptDefaultButton"),
                      },
                      on: { click: _vm.onAccept },
                    }),
                    _vm._v(" "),
                    _c("Button", {
                      attrs: {
                        level: "grey",
                        type: "button",
                        text: _vm.$t("cookiebanner.chooseButton"),
                      },
                      on: { click: _vm.openModal },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "modal",
          attrs: { "overlay-type": "cookie-consent" },
          on: { open: _vm.onModalOpen },
        },
        [
          _c(
            "div",
            { staticClass: "overlay-dialog" },
            [
              _c("h2", {
                staticClass:
                  "double-sided__content-title double-sided__content-title--colorful color-yellow",
                domProps: {
                  innerHTML: _vm._s(_vm.$t("cookiebanner.settings.title")),
                },
              }),
              _vm._v(" "),
              _vm._l(_vm.cookieCategories, function (category, index) {
                return _c(
                  "FormInputCheckbox",
                  {
                    key: index,
                    attrs: { disabled: category === _vm.defaultCookieCategory },
                    model: {
                      value: _vm.selectedCategories[category],
                      callback: function ($$v) {
                        _vm.$set(_vm.selectedCategories, category, $$v)
                      },
                      expression: "selectedCategories[category]",
                    },
                  },
                  [
                    _c("strong", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("cookiebanner.settings." + category + ".title")
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("div", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t(
                            "cookiebanner.settings." + category + ".description"
                          )
                        ),
                      },
                    }),
                  ]
                )
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "cookie-banner__buttons" },
                [
                  _c("Button", {
                    attrs: {
                      "data-consent-submit": "",
                      "data-consent-selection": _vm.selectedCategoriesFormatted,
                      level: "green",
                      type: "button",
                      text: _vm.$t("cookiebanner.settings.submitButton"),
                    },
                    on: { click: _vm.onAccept },
                  }),
                ],
                1
              ),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }